import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';

import { withAccount } from '../../components/AccountContext';
import JPSRespondentDetailComponent from './components/JPSRespondentDetailComponent';
import { growlActionSuccess, growlErrors } from '../../utils/NotificationUtil';
import { jobProfileInviteJPSMutate, jobProfileRemindJPS } from '../../services/apps/JobProfileService';
import { withGrowl } from '../../components/GrowlNotifications';
import { intlShape, growlShape } from '../../components/prop-types';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

const mapStateToProps = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

class JPSRespondentDetailComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSending: false,
      isPreview: false,
    };
    this.sendInviteEmail = this.sendInviteEmail.bind(this);
    this.sendRemindingEmail = this.sendRemindingEmail.bind(this);
    this.previewJPSSurvey = this.previewJPSSurvey.bind(this);
  }

  sendInviteEmail() {
    const {
      currentAccount, intl: { formatMessage }, data, growl,
    } = this.props;
    const { jobProfileSurvey } = data;
    if (jobProfileSurvey) {
      jobProfileInviteJPSMutate({
        jobProfileSurveyId: jobProfileSurvey.id,
        accountId: currentAccount,
      })
        .then(() => {
          growlActionSuccess(growl, formatMessage(messages.successNoti));
        })
        .catch((errors) => {
          growlErrors(growl, errors);
        });
    }
  }

  sendRemindingEmail() {
    const {
      currentAccount, intl: { formatMessage }, data, growl,
    } = this.props;
    const { jobProfileSurvey } = data;

    if (jobProfileSurvey) {
      jobProfileRemindJPS({
        jobProfileSurveyId: jobProfileSurvey.id,
        accountId: currentAccount,
      })
        .then(() => {
          growlActionSuccess(growl, formatMessage(messages.successNoti));
        })
        .catch((errors) => {
          growlErrors(growl, errors);
        });
    }
  }

  async previewJPSSurvey() {
    const { data } = this.props;
    const { jobProfileSurvey } = data;
    window.open(jobProfileSurvey.startUrl, '_blank');
  }

  render() {
    const {
      data, translatedTags,
    } = this.props;
    const { jobProfileSurvey } = data;
    const { emailSending, isPreview } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <JPSRespondentDetailComponent
              jobProfileSurvey={jobProfileSurvey}
              sendInviteEmail={this.sendInviteEmail}
              sendRemindingEmail={this.sendRemindingEmail}
              previewJPSSurvey={this.previewJPSSurvey}
              availableTranslations={translatedTags}
              emailSending={emailSending}
              isPreview={isPreview}
            />
          </div>
        </div>
      </div>
    );
  }
}

JPSRespondentDetailComp.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  growl: growlShape.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default withGrowl(
  connect(
    mapStateToProps,
  )(
    injectIntl(
      withAccount(JPSRespondentDetailComp),
    ),
  ),
);
